"use client";

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { createClient } from "@lib/utils/supabase/client";

export const useAuthSession = () => {
  const supabase = useMemo(() => createClient(), []);

  return useQuery({
    queryKey: ["auth-session"],
    queryFn: async () => {
      const { data, error } = await supabase.auth.getSession();

      if (error) {
        throw new Error("Failed to get session");
      }

      return data.session;
    },
  });
};
